import isElectron from '../../../utils/isElectron';

export type IntakeBrand =
  | 'spotify'
  | 'serato'
  | 'text-import'
  | 'build-from-track';

/** Widget keys the dashboard and DEFAULT_WIDGETS already address these by. */
export type IntakeSourceId =
  | 'spotifyImport'
  | 'textImport'
  | 'fileImport'
  | 'buildFromTrack';

export interface IntakeSource {
  id: IntakeSourceId;
  label: string;
  /** Leading word rendered heavier, where the brand carries the name. */
  emphasis?: string;
  description: string;
  to: string;
  iconKey: string;
  iconColor?: string;
  brand: IntakeBrand;
}

/**
 * The ways a crate gets started. Serato only exists on the desktop build, where
 * the local library is readable, so the web build offers file upload instead.
 */
export const listIntakeSources = (): IntakeSource[] => [
  {
    id: 'spotifyImport',
    label: 'Import',
    emphasis: 'Spotify',
    description: 'Import playlists from Spotify',
    to: '/my-crates/spotify',
    iconKey: 'spotifyIcon',
    brand: 'spotify',
  },
  isElectron()
    ? {
        id: 'textImport',
        label: 'Import',
        emphasis: 'Serato',
        description: 'Import playlists from Serato',
        to: '/my-crates/serato',
        iconKey: 'seratoIcon',
        brand: 'serato',
      }
    : {
        id: 'textImport',
        label: 'File Import',
        description: 'Upload playlists from files',
        to: '/my-crates/file',
        iconKey: 'uploadCloud',
        iconColor: '#00a2ff',
        brand: 'serato',
      },
  {
    id: 'fileImport',
    label: 'Import',
    emphasis: 'Text',
    description: 'Paste a tracklist to build a crate',
    to: '/my-crates/text',
    iconKey: 'textImport',
    brand: 'text-import',
  },
  {
    id: 'buildFromTrack',
    label: 'Build From Track',
    description: 'Create crates from track',
    to: '/my-crates/track',
    iconKey: 'buildFromTrackIcon',
    brand: 'build-from-track',
  },
];

export const findIntakeSource = (id: string): IntakeSource | undefined =>
  listIntakeSources().find((source) => source.id === id);

export const intakeSourceName = (source: IntakeSource): string =>
  source.emphasis ? `${source.emphasis} ${source.label}` : source.label;
